import { bbox, distance } from "src/js/util/turf";
import { CustomGeometries, DrawingItem } from "../typings/Drawings";
import { IPolygonSearch } from "react-migration/lib/typings/comparables/Comparables";
import { LatLngCoordinates } from "react-migration/lib/util/geoJson";

export const convertGeoJsonToPolygonGeoFilter = (geoJsonPoly: CustomGeometries): IPolygonSearch | null => {
  if (!geoJsonPoly) {
    return null;
  }
  if (geoJsonPoly.type === "MultiPolygon") {
    const toSinglePolygons = geoJsonPoly.coordinates.map((x) => x[0]);
    const latLngPoints = toSinglePolygons.map((x) =>
      x.map((p) => ({
        lat: p[1],
        lng: p[0],
      }))
    );
    const empty: LatLngCoordinates[] = [];
    const latLngCoordinates = empty.concat(...latLngPoints);
    return {
      coordinates: latLngCoordinates,
    };
  } else if (geoJsonPoly.type === "Polygon") {
    return {
      coordinates: geoJsonPoly.coordinates[0].map((point) => ({
        lat: point[1],
        lng: point[0],
      })),
    };
  } else {
    throw new Error("geoJsonPoly filter is not of a polygon type");
  }
};

export const polygonRadius = (polygon: DrawingItem | null | undefined) => {
  if (!polygon) return 0.0;
  const [minX, , maxX, maxY] = bbox(polygon.geometry);
  const diameter = distance([minX, maxY], [maxX, maxY], { units: "meters" });
  return diameter / 2;
};
